import recentVerifications from './recentVerifications';

const storageService = {
  recentVerifications,
  getValue: <TValue>(key: string, defaultValue?: TValue) => {
    const stringValue = localStorage.getItem(key);

    if (!stringValue) {
      return defaultValue ?? null;
    }

    const result = JSON.parse(stringValue) as TValue;

    return result;

  },
  setValue: <TValue>(key: string, value: TValue) => {

    if (!value) {
      localStorage.removeItem(key);

      return;
    }
    const stringValue = JSON.stringify(value);

    localStorage.setItem(key, stringValue);

    return;
  }
};

export default storageService;
